import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';
import { environment } from './environments/environment';

// En producción silenciamos console.log/debug/info para no filtrar datos (tokens, PII) a la
// consola del navegador. Se conservan warn/error (los usa el error boundary). NB: esto NO
// "bloquea la consola" (imposible en el navegador del usuario) — el fix de fondo para que el
// token no sea legible desde JS/consola es moverlo a una cookie httpOnly.
if (environment.production) {
  const noop = (): void => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));